import { render, staticRenderFns } from "./ReporteDesnutricion.vue?vue&type=template&id=73f29414"
import script from "./ReporteDesnutricion.vue?vue&type=script&lang=js"
export * from "./ReporteDesnutricion.vue?vue&type=script&lang=js"
import style0 from "./ReporteDesnutricion.vue?vue&type=style&index=0&id=73f29414&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports